import { render, staticRenderFns } from "./top-recommend.vue?vue&type=template&id=08319f94&scoped=true"
import script from "./top-recommend.vue?vue&type=script&lang=js"
export * from "./top-recommend.vue?vue&type=script&lang=js"
import style0 from "./top-recommend.vue?vue&type=style&index=0&id=08319f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08319f94",
  null
  
)

export default component.exports